import { useMemo } from "react";
import AppleService from "./AppleService";

export default function useAppleService() {
  return useMemo(() => new AppleService(), []);
}
